
import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  IconButton,
  Button,
  Box,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Divider,
  useTheme,
  useMediaQuery,
  Stack,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const NavBar = () => {
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const navLinks = [
    { label: 'Home', path: '/' },
    { label: 'Upload', path: '/upload' },
    { label: 'Search', path: '/search' },
    { label: 'Subscribe', path: '/subscribe' },
  ];

  const authLinks = !isAuthenticated
    ? [
        { label: 'Log In', path: '/login' },
        { label: 'Create Account', path: '/register' },
      ]
    : [
        { label: 'Log Out', path: '/', action: handleLogout },
      ];

  const toggleDrawer = () => setDrawerOpen(!drawerOpen);

  return (
    <>
      <AppBar
        position="static"
        sx={{
          backgroundColor: '#0d1b2a',
          height: 90,
          justifyContent: 'center',
        }}
      >
        <Toolbar
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            height: '100%',
            px: { xs: 2, md: 4 },
          }}
        >
          {/* Logo */}
          <Box display="flex" alignItems="center">
            <img
              src="/logo.png"
              alt="ProTechTion Logo"
              style={{ height: 60 }}
            />
          </Box>

          {/* Desktop Nav - Centered */}
          {!isMobile && (
            <Box
              sx={{
                position: 'absolute',
                left: '50%',
                transform: 'translateX(-50%)',
              }}
            >
              <Stack direction="row" spacing={3}>
                {[...navLinks, ...authLinks].map((link, i) =>
                  link.action ? (
                    <Button
                      key={i}
                      onClick={link.action}
                      sx={{
                        color: 'white',
                        fontWeight: 'bold',
                        fontSize: '1rem',
                        textTransform: 'none',
                      }}
                    >
                      {link.label}
                    </Button>
                  ) : (
                    <Button
                      key={i}
                      component={Link}
                      to={link.path}
                      sx={{
                        color: 'white',
                        fontWeight: 'bold',
                        fontSize: '1rem',
                        textTransform: 'none',
                      }}
                    >
                      {link.label}
                    </Button>
                  )
                )}
              </Stack>
            </Box>
          )}

          {/* Mobile Menu Button */}
          {isMobile && (
            <IconButton edge="end" color="inherit" onClick={toggleDrawer}>
              <MenuIcon />
            </IconButton>
          )}
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer */}
      <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer}>
        <Box
          sx={{
            width: 250,
            backgroundColor: '#f5f5f5',
            height: '100%',
          }}
          role="presentation"
          onClick={toggleDrawer}
        >
          <List>
            {[...navLinks, ...authLinks].map((link, i) =>
              link.action ? (
                <ListItem button key={i} onClick={link.action}>
                  <ListItemText primary={link.label} />
                </ListItem>
              ) : (
                <ListItem button component={Link} to={link.path} key={i}>
                  <ListItemText primary={link.label} />
                </ListItem>
              )
            )}
          </List>
          <Divider />
          <Box sx={{ textAlign: 'center', mt: 2, fontSize: '0.75rem', color: 'gray' }}>
            &copy; {new Date().getFullYear()} ProTechTion
          </Box>
        </Box>
      </Drawer>
    </>
  );
};

export default NavBar;
